import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/', '/bind', '/register']

router.beforeEach((to, from, next) => {
  NProgress.start();  // 开始进度条
  const token = getToken();  // 获取 token，检查用户是否已登录

  // 检查目标路由是否包含 username 参数
  if (to.params.username) {
    const username = to.params.username;  // 提取用户名（例如：17721865774）

    // 如果目标路径和当前路径不同，再执行请求并跳转
    if (to.path !== `/map/${username}`) {
      const infor = { username: username };

      store
        .dispatch("GetIERP", infor)
        .then((re) => {
          // 请求成功后跳转到正确的页面
          next();
        })
        .catch((err) => {
          // 错误处理，可以跳转到首页或错误页面
          next({ path: '/' });
        });
    } else {
      const infor = { username: username };
      // 如果当前路径已经是目标路径，直接继续路由
      store
      .dispatch("GetIERP", infor)
      .then((re) => {
        // 请求成功后跳转到正确的页面
        next();
      })
      .catch((err) => {
        // 错误处理，可以跳转到首页或错误页面
        next({ path: '/' });
      });
    }
  } else {
    next();  // 没有 username 参数时，直接继续路由
  }
});


router.afterEach(() => {
  NProgress.done();  // 停止加载进度条
});



Vue.config.productionTip = false

// 创建并挂载根实例
new Vue({
  router,  // 在Vue实例中使用路由
  store,   // 在Vue实例中使用状态管理
  render: h => h(App)
}).$mount('#app')
